import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';

export default {
  'navBar.lang': '语言',
  ...pages,
  ...menu,
  ...pwa,
};
